import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { FacultyFormValues } from "src/models/Faculty.model";
import Faculty from "../Layouts/Faculty";
import { showToast } from "src/utils/showToaster";
import { useAddFacultyMutation } from "src/services/FacultyService";

type Props = {
  onClose: () => void;
};

const AddFacultyWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: FacultyFormValues = {
    facultyName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    facultyName: string().required("Please enter faculty name"),
  });

  const [addFaculty] = useAddFacultyMutation();

  // Handle Submit
  const handleSubmit = (
    values: FacultyFormValues,
    { setSubmitting, resetForm }: FormikHelpers<FacultyFormValues>
  ) => {
    addFaculty(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Faculty
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddFacultyWrapper;
